import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "vip-status"
}
const _hoisted_2 = { key: 0 }

import { ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { vipService } from '@/services/vipService';
import { useAuthStore } from '@/store/modules/auth';
import { useUserStore } from '@/store/modules/user';


export default /*@__PURE__*/_defineComponent({
  __name: 'VipRedeemDialog',
  props: {
  visible: {
    type: Boolean,
    default: false
  }
},
  emits: ['update:visible', 'redeemed'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const authStore = useAuthStore();
const userStore = useUserStore();
const loading = ref(false);
const form = ref({
  code: ''
});

const userInfo = ref(null);

// 格式化日期
const formatDate = (dateString: string) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  });
};

// 监听对话框显示状态
watch(() => props.visible, (newVal) => {
  if (newVal) {
    fetchUserInfo();
  }
});

// 获取用户信息
const fetchUserInfo = async () => {
  try {
    userInfo.value = userStore.userInfo;
    if (!userInfo.value) {
      await userStore.fetchUserInfo();
      userInfo.value = userStore.userInfo;
    }
  } catch (error) {
    console.error('获取用户信息失败:', error);
  }
};

// 处理兑换
const handleRedeem = async () => {
  if (!form.value.code) {
    ElMessage.warning('请输入兑换码');
    return;
  }

  loading.value = true;
  try {
    const response = await vipService.redeemVipCode(form.value.code);
    if (response.code === 200) {
      ElMessage.success('兑换成功');
      form.value.code = '';
      await userStore.fetchUserInfo(); // 刷新用户信息
      userInfo.value = userStore.userInfo;
      emit('redeemed');
      closeDialog(); // 关闭对话框
    } else {
      ElMessage.error(response.message || '兑换失败');
    }
  } catch (error: any) {
    ElMessage.error(error.message || '兑换失败');
  } finally {
    loading.value = false;
  }
};

// 关闭对话框
const closeDialog = () => {
  emit('update:visible', false);
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": __props.visible,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:visible', $event))),
    title: "VIP兑换",
    width: "400px",
    "close-on-click-modal": false,
    class: "vip-redeem-dialog"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        model: form.value,
        onSubmit: _withModifiers(handleRedeem, ["prevent"])
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, { label: "兑换码" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: form.value.code,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.code) = $event)),
                placeholder: "请输入VIP兑换码",
                disabled: loading.value
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                loading: loading.value,
                onClick: handleRedeem,
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createTextVNode(" 立即兑换 ")
                ])),
                _: 1
              }, 8, ["loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"]),
      (userInfo.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("p", null, "VIP等级：" + _toDisplayString(userInfo.value.vip === 0 ? '普通用户' : `VIP${userInfo.value.vip}`), 1),
            (userInfo.value.vipExpiresAt)
              ? (_openBlock(), _createElementBlock("p", _hoisted_2, " 到期时间：" + _toDisplayString(formatDate(userInfo.value.vipExpiresAt)), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})